import { PredictedVolumeCapsuleDoughnut } from 'widgets/liquiditySummary/predictedVolumeCapsule/components/PredictedVolumeCapsuleDoughnut';
import React from 'react';
import { PredictedVolumeCapsuleData } from 'widgets/liquiditySummary/predictedVolumeCapsule/components/predictedVolumeCapsuleData';

import './PredictedVolumeCapsuleContent.scss';
import classNames from 'classnames';
export function PredictedVolumeCapsuleContent({
    chartData,
    cssClasses,
}: {
    chartData: PredictedVolumeCapsuleData | undefined;
    cssClasses?: string;
}) {
    return (
        <div
            className={classNames('PredictedVolumeCapsuleContent', cssClasses)}
        >
            {chartData && <PredictedVolumeCapsuleDoughnut data={chartData} />}
        </div>
    );
}
